import { CommonModule } from '@angular/common'
import { Component } from '@angular/core'
import { Router } from '@angular/router'

/**
 * Represents a cancelled upgrade redirection
 */
@Component({
  selector: 'ngx-cancelled-upgrade',
  templateUrl: './cancelled-upgrade.component.html',
  styleUrls: ['./cancelled-upgrade.component.scss'],
  imports: [CommonModule]
})
export class CancelledUpgradeComponent {
  /**
   * Creates the component and injects it's dependencies
   * @param router Router
   */
  constructor(private router: Router) {}
  /**
   * Navigates to event timeline view
   */
  navigateWorkspace() {
    this.router.navigate(['workspaces', 'list'])
  }
}
